import { useThemeSlice } from "../../components/ui/StatusBadge.jsx";
import { useReportBuilder, useReportBuilderBootstrap } from "../../logic/hooks/useReportBuilder.js";
import { ReportBuilderHeader } from "./ReportBuilderHeader.jsx";
import { ReportBuilderConfigPanel } from "./ReportBuilderConfigPanel.jsx";
import { ReportBuilderInspector } from "./ReportBuilderInspector.jsx";
import { rbCardStyle } from "./reportBuilderTheme.js";

export function ReportBuilderPage() {
  const { c, dark, accentHex: A } = useThemeSlice();
  useReportBuilderBootstrap();
  const vm = useReportBuilder();

  const canGoPrev = vm.stepIndex > 0;
  const canGoNext = vm.stepIndex < vm.steps.length - 1 && !vm.stepError;
  const cardLift = dark ? "0 20px 42px rgba(0,0,0,.34)" : "0 16px 36px rgba(15,23,42,.10)";

  return (
    <div style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0, overflow: "hidden", padding: 14 }}>
      <div
        style={{
          ...rbCardStyle(c, dark),
          boxShadow: cardLift,
          display: "flex",
          flexDirection: "column",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
          padding: 16,
        }}
      >
        <ReportBuilderHeader
          steps={vm.steps}
          activeStep={vm.step}
          stepIndex={vm.stepIndex}
          title={vm.currentStep.label}
          description={vm.currentStep.description}
          onStepClick={vm.goToStep}
          onPrev={vm.goPrev}
          onNext={vm.goNext}
          canGoPrev={canGoPrev}
          canGoNext={canGoNext}
          stepError={vm.stepError}
          c={c}
          A={A}
          dark={dark}
        />

        <div style={{ display: "flex", gap: 14, flex: 1, minHeight: 0, overflow: "hidden" }}>
          <div style={{ flex: 1, minWidth: 0, overflowY: "auto", minHeight: 0, paddingRight: 4 }}>
            <ReportBuilderConfigPanel vm={vm} c={c} dark={dark} A={A} />
          </div>

          <ReportBuilderInspector
            config={vm.config}
            dataset={vm.dataset}
            queryPreview={vm.queryPreview}
            estimate={vm.estimate}
            estimateLoading={vm.estimateLoading}
            c={c}
            A={A}
            dark={dark}
          />
        </div>
      </div>
    </div>
  );
}
